// extracted by mini-css-extract-plugin
module.exports = {"suspend":"floatWindow_suspend_3GmKV"};